import React from "react"
import {timeOutline, timeSharp} from "ionicons/icons"

import TypeIcon from "./TypeIcon"

interface props {
    link?: string
    size?: "small" | "default" | "large"
    slot?: string
    text?: string
}

const IconTimeLimit: React.FC<props> = ({ link, size, slot, text }) => {

    return <TypeIcon
        backgroundColor={'darkkhaki'}
        link={link}
        ios={timeOutline}
        md={timeSharp}
        size={size}
        slot={slot}
        text={text}
    />
}

export default IconTimeLimit